export default {
  noActiveRecipe: 'No active recipe in chamber {chamber}.',
  noDataSourceConnected: 'This chamber {chamber} is missing the link to a ProTherm controller. The link may be establish in the asset management.',
  goToNextStep: 'Advance to step {step}',
  goToPreviousStep: 'Revert to step {step}',
};
